module.exports = __webpack_public_path__ + "static/img/product-poster-4.58daf00c.png";